import { createReducer, createNamespacer } from '../commons/js/utils/reducer';
import { combineReducers } from "redux";
import { fromPairs as _fromPairs, startCase } from 'lodash';


const namespacers = {
    addUser: createNamespacer("ADD_USER"),
    listUsers: createNamespacer("USER_LIST"),
    editUser: createNamespacer("EDIT_USER"),
    procurementEmail: createNamespacer("EDIT_OUTLOOK_PASSWORD"),
}

const initialState = {
    list: {
        showAddUser: false,
        showEditUser: false,
        showChangePassword: false,
        isLoading: false,
        users: [],
        error: "",
        currentPage: 1,
        pageCount: 0,
        search: '',
        selectedUserType: "",
        userTypesList: [],
    },
    addUser: {
        firstname: {
            value: "",
            error: "",
            showError: "",
        },
        lastname: {
            value: "",
            error: "",
            showError: "",
        },
        email: {
            value: "",
            error: "",
            showError: "",
        },
        welderId: {
            value: "",
            error: "",
            showError: "",
        },
        contactNumber: {
            value: "",
            error: "",
            showError: "",
        },
        userType: {
            value: "",
            error: "",
            showError: "",
        },
        username: {
            value: "",
            error: "",
            showError: "",
        },
        password: {
            value: "",
            error: "",
            showError: "",
        },
        confirmPassword: {
            value: "",
            error: "",
            showError: "",
        },
        profilePicture: {
            value: "",
            error: "",
            showError: "",
        },
        roles: [],
        error: '',
        pictureSelected: false,
    },
    editUser: {
        firstname: {
            value: "",
            error: "",
            showError: "",
        },
        lastname: {
            value: "",
            error: "",
            showError: "",
        },
        email: {
            value: "",
            error: "",
            showError: "",
        },
        welderId: {
            value: "",
            error: "",
            showError: "",
        },
        contactNumber: {
            value: "",
            error: "",
            showError: "",
        },
        userType: {
            value: "",
            error: "",
            showError: "",
        },
        username: {
            value: "",
            error: "",
            showError: "",
        },
        profilePicture: {
            value: "",
            error: "",
            showError: "",
        },
        invitationStatus: {
            value: "",
            error: "",
            showError: "",
        },
        outlookEmail: {
            value: "",
            error: "",
            showError: "",
        },
        outlookPassword: {
            value: "",
            error: "",
            showError: "",
        },
        roles: [],
        profilePictureSelected: false,
        customErrors: {},
    },
    procurementEmail: {
        password: {
            value: "",
            error: "",
            showError: "",
        },
        confirmPassword: {
            value: "",
            error: "",
            showError: "",
        },
    }
}

const listReducer = createReducer(initialState.list, {
    "SET_SHOW_ADD_USER": (state, action) => {
        return {
            ...state,
            showAddUser: action.payload.value,
        }
    },
    "SET_SHOW_EDIT_USER": (state, action) => {
        return {
            ...state,
            showEditUser: action.payload.value,
        }
    },
    "SET_SHOW_CHANGE_PASSWORD": (state, action) => {
        return {
            ...state,
            showChangePassword: action.payload.value,
        }
    },
    [namespacers.listUsers('SET_USERS_SEARCH')] :(state, action) => {
        return {
            ...state,
            search: action.payload.value,
        }
    },
    [namespacers.listUsers('CLEAR_USERS_SEARCH')] :(state) => {
        return {
            ...state,
            search: initialState.search,
        }
    },
    [namespacers.listUsers("SET_LOADING")]: (state, action) => {
        return {
            ...state,
            isLoading: action.payload.value,
        }
    },
    [namespacers.listUsers("SET_USERS")]: (state, action) => {
        return {
            ...state,
            users: action.payload.value,
            pageCount: action.payload.pages,
        }
    },
    [namespacers.listUsers("SET_PAGE")]: (state, action) => {
        return {
            ...state,
            currentPage: action.payload.value,
        }
    },
    [namespacers.listUsers("SET_ERROR")]: (state, action) => {
        return {
            ...state,
            error: action.payload.value,
        }
    },
    [namespacers.listUsers("SET_ROLES")]: (state, action) => {
        return {
            ...state,
            userTypesList: action.payload.value,
        }
    },
    [namespacers.listUsers("SET_SELECTED_USER_TYPE")]: (state, action) => {
        return {
            ...state,
            selectedUserType: action.payload.value,
        }
    },
});

const addUserReducer = createReducer(initialState.addUser, {
    [namespacers.addUser("SET_FIRSTNAME")]: (state, action) => {
        return {
            ...state,
            firstname: {
                ...state.firstname,
                value: action.payload.value
            },
        }
    },
    [namespacers.addUser("SET_LASTNAME")]: (state, action) => {
        return {
            ...state,
            lastname: {
                ...state.lastname,
                value: action.payload.value
            },
        }
    },
    [namespacers.addUser("SET_EMAIL")]: (state, action) => {
        return {
            ...state,
            email: {
                ...state.email,
                value: action.payload.value
            },
        }
    },
    [namespacers.addUser("SET_WELDER_ID")]: (state, action) => {
        return {
            ...state,
            welderId: {
                ...state.welderId,
                value: action.payload.value
            },
        }
    },
    [namespacers.addUser("SET_CONTACT_NUMBER")]: (state, action) => {
        return {
            ...state,
            contactNumber: {
                ...state.contactNumber,
                value: action.payload.value
            },
        }
    },
    [namespacers.addUser("SET_USER_TYPE")]: (state, action) => {
        return {
            ...state,
            userType: {
                ...state.userType,
                value: action.payload.value
            },
        }
    },
    [namespacers.addUser("SET_USERNAME")]: (state, action) => {
        return {
            ...state,
            username: {
                ...state.username,
                value: action.payload.value
            },
        }
    },
    [namespacers.addUser("SET_PASSWORD")]: (state, action) => {
        return {
            ...state,
            password: {
                ...state.password,
                value: action.payload.value
            },
        }
    },
    [namespacers.addUser("SET_CONFIRM_PASSWORD")]: (state, action) => {
        return {
            ...state,
            confirmPassword: {
                ...state.confirmPassword,
                value: action.payload.value
            },
        }
    },
    [namespacers.addUser("SET_PROFILE_PICTURE")]: (state, action) => {
        return {
            ...state,
            profilePicture: {
                ...state.profilePicture,
                value: action.payload.value
            },
            pictureSelected: true,
        }
    },
    [namespacers.addUser("SET_ERROR")]: (state, action) => {
        return {
            ...state,
            error: action.payload.value,
        }
    },
    [namespacers.addUser("CLEAR_FORM")]: (state, action) => {
        return {
            ...initialState.addUser,
        }
    },
    [namespacers.addUser("SET_ROLES")]: (state, action) => {
        return {
            ...state,
            roles: action.payload.value,
        }
    },
    [namespacers.addUser("SET_FIELD_ERRORS")]: (state, action) => {
        let errors = action.payload.value;

        const loadedFields = _fromPairs(Object.entries(errors).map((error) => {
            const [key, value] = error;
            return [key, {
                ...state[key],
                error: value
            }]
        }))

        return {
            ...state,
            ...loadedFields,
        }
    },
});

const procurementEmailReducer = createReducer(initialState.procurementEmail, {
    [namespacers.procurementEmail("SET_NEW_PASSWORD")]: (state, action) => {
        return {
            ...state,
            password: {
                ...state.password,
                value: action.payload.value
            },
        }
    },
    [namespacers.procurementEmail("SET_CONFIRM_PASSWORD")]: (state, action) => {
        return {
            ...state,
            confirmPassword: {
                ...state.confirmPassword,
                value: action.payload.value
            },
        }
    },
    [namespacers.procurementEmail("CLEAR_FORM")]: (state, action) => {
        return initialState.procurementEmail;
    },
    [namespacers.procurementEmail("SET_FIELD_ERRORS")]: (state, action) => {
        let errors = action.payload.value;

        const loadedFields = _fromPairs(Object.entries(errors).map((error) => {
            const [key, value] = error;
            return [key, {
                ...state[key],
                error: value
            }]
        }))

        return {
            ...state,
            ...loadedFields,
        }
    },
});

const editUserReducer = createReducer(initialState.editUser, {
    [namespacers.editUser("SET_FIRSTNAME")]: (state, action) => {
        return {
            ...state,
            firstname: {
                ...state.firstname,
                value: action.payload.value,
            },
        }
    },
    [namespacers.editUser("SET_LASTNAME")]: (state, action) => {
        return {
            ...state,
            lastname: {
                ...state.lastname,
                value: action.payload.value,
            },
        }
    },
    [namespacers.editUser("SET_EMAIL")]: (state, action) => {
        return {
            ...state,
            email: {
                ...state.email,
                value: action.payload.value
            },
        }
    },
    [namespacers.editUser("SET_WELDER_ID")]: (state, action) => {
        return {
            ...state,
            welderId: {
                ...state.welderId,
                value: action.payload.value
            },
        }
    },
    [namespacers.editUser("SET_CONTACT_NUMBER")]: (state, action) => {
        return {
            ...state,
            contactNumber: {
                ...state.contactNumber,
                value: action.payload.value
            },
        }
    },
    [namespacers.editUser("SET_PROFILE_PICTURE")]: (state, action) => {
        return {
            ...state,
            profilePicture: {
                ...state.profilePicture,
                value: action.payload.value
            },
            profilePictureSelected: true,
        }
    },
    [namespacers.editUser("SET_USER_TYPE")]: (state, action) => {
        return {
            ...state,
            userType: {
                ...state.userType,
                value: action.payload.value
            },
        }
    },
    [namespacers.editUser("SET_USERNAME")]: (state, action) => {
        return {
            ...state,
            username: {
                ...state.username,
                value: action.payload.value
            },
        }
    },
    [namespacers.editUser("SET_OUTLOOK_EMAIL")]: (state, action) => {
        return {
            ...state,
            outlookEmail: {
                ...state.outlookEmail,
                value: action.payload.value
            },
        }
    },
    [namespacers.editUser("SET_OUTLOOK_PASSWORD")]: (state, action) => {
        return {
            ...state,
            outlookPassword: {
                ...state.outlookPassword,
                value: action.payload.value
            },
        }
    },
    [namespacers.editUser("SET_INVITATION_STATUS")]: (state, action) => {
        return {
            ...state,
            invitationStatus: {
                ...state.invitationStatus,
                value: action.payload.value
            },
        }
    },
    [namespacers.editUser("SET_CUSTOM_ERRORS")]: (state, action) => {
        return {
            ...state,
            customErrors: action.payload.value
        }
    },
    [namespacers.editUser("SET_USER_NAME_ERRORS")]: (state, action) => {
        return {
            ...state,
            username: {
                ...state.username,
                error: action.payload.error,
            },
        }
    },
    [namespacers.editUser("LOAD_DATA")]: (state, action) => {
        const responseMapping = {
            firstname: 'first_name',
            lastname: 'last_name',
            email: 'email',
            contactNumber: 'mobile',
            username: 'user_name',
            welderId: 'welder_id',
            invitationStatus: 'invitation_status',
        }

        const loadedFields = _fromPairs(
            Object.entries(responseMapping).map(([key, responseKey]) => {
                return [key, {
                    ...state[key],
                    value: action.payload.value[responseKey]
                }]
            })
        )

        const role = action.payload.roles.find((role) => {
            if(action.payload.value.role === "qa"){
                return role.label === "QA/QC"
            }else{
                return role.label === startCase(action.payload.value.role.split("_").join(" "))
            }
        })

        loadedFields.userType = {
            ...state["userType"],
            value: role,
        }

        let profilePicture = action.payload.value.thumb_url || "";


        return {
            ...state,
            ...loadedFields,
            profilePicture: {
                ...state.profilePicture,
                value: profilePicture,
            },
            roles: action.payload.roles,
            topManager: action.payload.top_manager
        }
    },
    [namespacers.editUser("SET_ERROR")]: (state, action) => {
        return {
            ...state,
            error: action.payload.value,
        }
    },
    [namespacers.editUser("CLEAR_FORM")]: (state, action) => {
        return {
            ...initialState.editUser,
        }
    },
    [namespacers.editUser("SET_FIELD_ERRORS")]: (state, action) => {
        let errors = action.payload.value;

        const loadedFields = _fromPairs(Object.entries(errors).map((error) => {
            const [key, value] = error;
            return [key, {
                ...state[key],
                error: value
            }]
        }))

        return {
            ...state,
            ...loadedFields,
        }
    },
});

const reducer = combineReducers({
    list: listReducer,
    addUser: addUserReducer,
    editUser: editUserReducer,
    procurementEmail: procurementEmailReducer,
})

export default reducer;